import React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link, NavLink } from 'react-router-dom';
import './Header.css'
const Header = () => {
    return (
        <Navbar collapseOnSelect expand="lg" bg="primary" variant="dark">
            <Container>
                <Link className='navbar-brand fs-3 fw-bold' to="/">Web<span className='text-warning'>Testy</span></Link>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="w-100 justify-content-end">
                        <NavLink className={({ isActive })=>isActive ? 'nav-link' : undefined} to="/">Home</NavLink>
                        <NavLink className='nav-link' to="/statistics">Statistics</NavLink>
                        <NavLink className='nav-link' to="/blogs">Blog</NavLink>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
        
    );
};

export default Header;